import React from 'react';
import { defineMessages, intlShape } from 'react-intl';

import { BrowserNotificationsHandler } from '../../../../../../components/BrowserNotificationsHandler';
import getCsrfToken from '../../../../../../utils/app/getCsrfToken';
import { supportSWPushNotification } from '../../../../../../utils/notifications';
import { trackEvent } from '../../../../../../utils/platform';

import PromptContent from './PromptContent';

interface Props {
    webPushVapidPublicKey: string | null;
    xhrNotificationsUserFlag: string;
    showEnableBrowserNotificationsPrompt: boolean;
}

interface State {
    hasDeclined: boolean;
    supportSWPushNotification: boolean;
}

defineMessages({
    title: {
        id: 'notification.title',
        defaultMessage: 'A notification from 99designs',
    },
    body: {
        id: 'notification.body',
        defaultMessage:
            'Nice, notifications are enabled! Customise notifications in your account settings.',
    },
});

export class EnableBrowserNotificationPrompt extends React.Component<Props, State> {
    state = {
        hasDeclined: false,
        supportSWPushNotification: false,
    };

    static contextTypes = {
        intl: intlShape,
    };

    context: any;

    componentDidMount() {
        supportSWPushNotification().then(
            result => {
                this.setState({ supportSWPushNotification: result });
            },
            () => {}
        );
    }

    handleDeclineButtonClick = () => {
        trackEvent('Decline Browser Notifications Prompt Button Clicked');
        fetch(this.props.xhrNotificationsUserFlag, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type: 'declined-browser-notifications',
                csrf_token: getCsrfToken(),
            }),
            credentials: 'same-origin',
        }).then(
            () => {
                this.setState({ hasDeclined: true });
            },
            () => {}
        );
    };

    render() {
        const { webPushVapidPublicKey, showEnableBrowserNotificationsPrompt } = this.props;
        const { hasDeclined, supportSWPushNotification } = this.state;
        const { intl } = this.context;

        if (!supportSWPushNotification) {
            return null;
        }

        return (
            <BrowserNotificationsHandler
                webPushVAPIDPublicKey={webPushVapidPublicKey}
                welcomeNotification={{
                    title: intl.formatMessage({ id: 'notification.title' }),
                    body: intl.formatMessage({
                        id: 'notification.body',
                    }),
                    clickURL: '/account/notifications',
                }}
                render={props => (
                    <PromptContent
                        {...props}
                        showEnableBrowserNotificationsPrompt={showEnableBrowserNotificationsPrompt}
                        hasDeclined={hasDeclined}
                        handleDeclineButtonClick={this.handleDeclineButtonClick}
                    />
                )}
            />
        );
    }
}

export default EnableBrowserNotificationPrompt;
